import { Box, Divider, Flex, Text } from "@chakra-ui/react";
import { memo, useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import ShopItem from "components/Common/ShopItem/ShopItem";
import Swipeable from "components/Swipeable";
import { useGetSuggestionsQuery } from "graphql/generated";
import graphQLClient from "graphql/react-query";
import { cartState, platformState, suggestionItemsState } from "src/states";

const NUMBER_OF_ITEMS = 2;
interface Props {
  t: (key: string, values?) => string;
}

const RecommendSection = ({ t }: Props) => {
  const [suggestionItems, setSuggestionItems] = useRecoilState(suggestionItemsState);
  const platform = useRecoilValue(platformState);
  const cart = useRecoilValue(cartState);
  const { data: getSuggestionsData, refetch } = useGetSuggestionsQuery(graphQLClient, {
    input: {
      platform
    }
  });

  useEffect(() => {
    // TODO: 2 api calls at the initial start. This can only be fixed if we move cart.cartItems as a dependency in graphql api input => it will auto-refetch instead of using useEffect
    refetch();
    setSuggestionItems(getSuggestionsData.getSuggestions || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart.cartItems]);

  return suggestionItems ? (
    <Flex justifyContent="center" direction="column">
      <Flex w="100%" mb="36px">
        <Flex flex={1} alignItems="center">
          <Divider bg="primary.300" borderColor="primary.300" border="1.5px" />
        </Flex>
        <Text color="primary.300" mx="40px" fontSize="sm">
          {t("other-products-title")}
        </Text>
        <Flex flex={1} alignItems="center">
          <Divider bg="primary.300" borderColor="primary.300" border="1.5px" />
        </Flex>
      </Flex>

      {suggestionItems?.length > 0 ? (
        <Box>
          <Swipeable
            itemsToShow={NUMBER_OF_ITEMS}
            showPercent={false}
            wrapperStyle={{ w: "100%" }}
            isDirection={suggestionItems?.length > NUMBER_OF_ITEMS}
          >
            {suggestionItems.map((currentItem: any) => (
              <ShopItem
                t={t}
                key={currentItem.id}
                {...currentItem}
                descriptionWrapperMinH="280px"
                wrapperStyle={{ w: { base: "auto" }, mx: { base: "5px", md: "25px" } }}
                hideBuyButton
                isSuggestion
              />
            ))}
          </Swipeable>
        </Box>
      ) : (
        <Text textAlign="center" fontSize={{ base: "md", md: "lg" }}>
          {t("checkout:bought-all-message")}
        </Text>
      )}
    </Flex>
  ) : null;
};

export default memo(RecommendSection);
